export const tagColorPalette = ["#2563EB", "#15803D", "#DC2626", "#CA8A04", "#7C3AED", "#0284C7", "#A16207", "#475569"];

export function nextTagPaletteColor(existingCount: number) {
  return tagColorPalette[existingCount % tagColorPalette.length];
}
